
import './App.css';
import Navbar1 from './components/Navbar1';
import {
  BrowserRouter as Router,
} from "react-router-dom";
import Footer from './components/Footer';
import Routing from './Routing';
import ScrollToTop from "./ScrollToTop";

function App() {
  return (
    <>
      <Router>
      <ScrollToTop>
        <Navbar1 />
          <Routing />
        <Footer />
        </ScrollToTop>
      </Router>
    </>
  );
}

export default App;
